import { Feature } from "@cs124/jeed-types";
import { Array as RuntypeArray } from "runtypes";
export const DEFAULT_MAX_PAYLOAD = 8 * 1024 * 1024;
export const questionFeatures = (question) => RuntypeArray(Feature).check(Object.keys(question.classification.featuresByLanguage.java.featureMap)).filter((feature) => question.classification.featuresByLanguage.java.featureMap[feature] > 0);
export * from "./cache";
export * from "./collaboration";
export * from "./collections";
export * from "./coordinates";
export * from "./deadline";
export * from "./output";
export * from "./points";
export * from "./results";
export * from "./submission";
export * from "./testtestingoutput";
export * from "./walkthroughpermission";
//# sourceMappingURL=index.js.map
